import axios from 'axios'
import sanitizeAddress from '@/utils/sanitizeAddress'

/**
 * Binds address and consumer details with the given card.
 * Assigns the given country code to the addresses.
 *
 * @param {Object} payload
 * @param {Object} payload.billingAddress
 * @param {Object} payload.shippingAddress
 * @param {Object} payload.consumer
 * @param {Object} payload.assuranceData
 * @param {Object} payload.appInstance
 * @param {Object} payload.srcDigitalCardId
 * @param {Object} payload.srcPaymentCardId
 * @param {Object} payload.srcConsumerId
 * @param {Object} payload.srcDeviceId
 * @returns {Promise<Object>}
 */

export default function bind(payload, cardAuthToken) {
  const headers = {}

  if (cardAuthToken) {
    headers['X-SRC-CARD-TOKEN'] = cardAuthToken
  }

  /** TODO: Maybe move the following to useBindUserData and migrate Bulk to use that composable. */

  if (payload.billingAddress) {
    payload.billingAddress = sanitizeAddress(payload.billingAddress)
  }

  if (payload.shippingAddress) {
    payload.shippingAddress = sanitizeAddress(payload.shippingAddress)
  }

  return axios.post('/api/bind', payload, { headers })
}
